import { actions } from "../framework/actions"

export const LogoutUser = (dispatch) => async () => dispatch(actions.doLogout())

export default LogoutUser
